export default "__VITE_ASSET__82969bbc__"